import React from 'react';

const Error404 = () => {
  return <div>Error404</div>;
};

Error404.propTypes = {};

export default Error404;
